export const tickerConfig = {
    name: 'Ticker',
    image: 'https://cdn.zappy.app/8f021029c383bf02f190aae8bfca7c2f.svg',
    category: 'Zapier Blocks',
    canHaveChildren: true,
    includeScrollTracking: true,
    inputs: [
        {
            name: 'speed',
            type: 'string',
            enum: ['slow', 'normal', 'fast'],
            defaultValue: 'normal',
        },
        {
            name: 'reversed',
            type: 'boolean',
        },
        {
            name: 'compact',
            type: 'boolean',
        },
    ],
};
//# sourceMappingURL=config.js.map